import { Flex, Tooltip } from '@chakra-ui/react'
import { CircleDiv, CircleCard, CardDiv, BackgroundCard, BodyCard, FlexElipse, EditMenu, FlexBetween } from './styles'
import { CardReuniao } from './components/CardReuniao'
import { CardIntegracao } from './components/CardIntegracao'
import { CardPesquisa } from './components/CardPesquisa'
import { CardPesquisaStackholder } from './components/CardPesquisaStackholder'
import { CardImersao } from './components/CardImersao'
import { iEtapaColaborador, iInteracaoEtapa } from '../../../../../interfaces'
import { FaAngleDown, FaAngleUp, FaCheck, FaEye, FaEyeSlash, FaPen, FaTrash } from 'react-icons/fa'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ObterCorEtapaPeloTipo, ObterCorFundoEtapaPeloTipo, PropInvalida } from '../../../../../Utils/Helper'
import { CardEnps } from '../CardEnps'
import { CardReuniaoOne } from './components/CardReuniaoOne'
import { CardPDI } from './components/CardPDI'

interface ICardOboardConfig {
  etapa: iEtapaColaborador
  isLast: boolean
  disabledMenu?: boolean
  processoId: string
  colaboradorId: string
  email: string
  onDeleteEtapa: (Id: string) => void
  onConcludeEtapa: (Id: string) => void
  onUpdateVisibility: (Id: string) => void
}

export const BoardBox: React.FC<ICardOboardConfig> = ({ processoId, colaboradorId, email, etapa, isLast, disabledMenu, onDeleteEtapa, onConcludeEtapa, onUpdateVisibility }) => {
  const [isOpen, setisOpen] = useState(false)
  const Cor = ObterCorEtapaPeloTipo(etapa.tipo)
  const CorFundo = ObterCorFundoEtapaPeloTipo(etapa.tipo)

  function ObterComponentePeloTipoEtapa(key: number): any {
    if (etapa.tipo === 1) {
      return (
        <CardIntegracao key={key} IntegracaoId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 2) {
      return (
        <CardReuniao processoId={processoId} key={key} ReuniaoId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 3) {
      return (
        <CardImersao key={key} ImersaoId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 4) {
      return (
        <CardPesquisa key={key} InteracaoId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 5) {
      return (
        <CardPesquisaStackholder key={key} pesquisaId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 6) {
      return (
        <CardEnps key={key} email={email} pesquisaId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 7) {
      return (
        <CardReuniaoOne key={key} etapaId={etapa.id} reuniaoId={etapa.interacoes[0].idExterno} />
      )
    } else if (etapa.tipo === 9) {
      return (
        <CardPDI key={key} etapaId={etapa.id}/>
      )
    }
  }

  function ObterRedirectPeloTipo(Tipo: number): string {
    if (Tipo === 1) {
      return `/Jornada/Processo/${colaboradorId}/Integracao/${etapa.interacoes[0].idExterno}/Editar/${etapa.id}`
    } else if (Tipo === 2) {
      return `/Jornada/Processo/${colaboradorId}/Reuniao/Editar/${etapa.id}`
    } else if (Tipo === 3) {
      return `/Jornada/Processo/${colaboradorId}/Imersao/${etapa.interacoes[0].idExterno}/Editar/${etapa.id}`
    } else if (Tipo === 4) {
      return `/Jornada/Processo/${processoId}/PesquisaInterna/Editar/${etapa.id}`
    } else if (Tipo === 5) {
      return `/Rh/PesquisaPercepcao/Editar/${etapa.id}/Processo/${processoId}`
    } else if (Tipo === 6) {
      return `/Jornada/Processo/${processoId}/eNps/Editar/${etapa.id}`
    } else if (Tipo === 7) {
      return `/Jornada/Processo/${processoId}/ReuniaoOne/Configuracao/${etapa.id}`
    } else if (etapa.tipo === 9) {
      return `/Jornada/Processo/${colaboradorId ?? ''}/PDI/${etapa.id}`
    }
    return ''
  }

  function ObterChildrenPorStatus(): any {
    if (etapa.status === 0) { // Liberado
      return (
        <span style={{ fontSize: '0.825rem' }}>Liberado</span>
      )
    }

    if (etapa.status === 1) { // Etapa anterior
      return (
        <span style={{ fontSize: '0.825rem' }}>Após a anterior</span>
      )
    }

    if (etapa.status === 2) { // Finalizado
      return (
        <FaCheck color='var(--terc6)' size={28} />
      )
    }

    if (etapa.status === 3 && PropInvalida(etapa.dataInicio)) { // Data indefinida
      return (
        <span style={{ fontSize: '0.825rem' }}>Aguarde a data</span>
      )
    }

    if (etapa.status === 4 || etapa.dataInicio) { // Data de inicio
      return (
        <span style={{ fontSize: '1rem' }}>{etapa.dataInicio}</span>
      )
    }

    if (etapa.status === 5) { // Demitido
      return (
        <span style={{ fontSize: '0.825rem' }}>Interrompido</span>
      )
    }

    if (etapa.status === 6) { // Atrasado
      return (
        <span style={{ fontSize: '0.825rem' }}>Atrasada</span>
      )
    }

    if (etapa.status === 7) { // Em andamento
      return (
        <span style={{ fontSize: '0.80rem' }}>Em andamento</span>
      )
    }
  }

  return (
    <Flex>
      <CircleDiv>
        <CircleCard>{ObterChildrenPorStatus()}</CircleCard>
        {
          (!isLast) && (
            <hr />
          )
        }
      </CircleDiv>
      <FlexElipse color={Cor}>
        <div></div>
        <div></div>
        <div></div>
      </FlexElipse>
      <BackgroundCard isOpen={isOpen} theme={CorFundo}>
        <CardDiv disable={etapa.tipo === 0} onClick={() => !PropInvalida(etapa.interacoes) && setisOpen(!isOpen)} theme={Cor}>
          <FlexBetween>
            <Flex alignItems={'center'}>
              <h3>{etapa.nome}</h3>
            </Flex>
            {
              (etapa.tipo !== 0 && !PropInvalida(etapa.interacoes)) && (
                !isOpen
                  ? <FaAngleDown size={'1.5rem'} />
                  : <FaAngleUp size={'1.5rem'} />
              )
            }
          </FlexBetween>
          <span>{etapa.descricao}</span>
        </CardDiv>
        {
          <BodyCard isOpen={isOpen}>
            {
              !PropInvalida(etapa.interacoes) && etapa.interacoes.map((obj: iInteracaoEtapa, i) => {
                return ObterComponentePeloTipoEtapa(i)
              })
            }
          </BodyCard>
        }
      </BackgroundCard>

      {
        (!disabledMenu && !PropInvalida(etapa.interacoes)) && (
          <EditMenu isOpen={isOpen}>
            {
              (etapa.interacoes[0].tipo > 0 && etapa.status !== 2) && (
                <>
                  {
                    (!etapa.bloquearEdicao) && (
                      <Tooltip
                        padding='2'
                        borderRadius='4'
                        placement='top'
                        color={'white'}
                        background={'var(--a4)'}
                        label='Clique aqui para editar a etapa'
                        hasArrow arrowSize={15}
                      >
                        <Link
                          data-bt="edit"
                          to={ObterRedirectPeloTipo(etapa.interacoes[0].tipo)}>
                          <FaPen style={{ marginLeft: '1rem' }} /></Link>
                      </Tooltip>
                    )
                  }

                  <Tooltip
                    padding='2'
                    borderRadius='4'
                    placement='top'
                    color={'white'}
                    background={'var(--a4)'}
                    label='Clique aqui para excluir a etapa'
                    hasArrow arrowSize={15}
                  >
                    <a data-bt="trash" onClick={() => onDeleteEtapa(etapa.id)}><FaTrash /></a>
                  </Tooltip>
                </>

              )
            }
            {
              (etapa.status !== 2) && (
                <Tooltip
                  padding='2'
                  borderRadius='4'
                  placement='top'
                  color={'white'}
                  background={'var(--a4)'}
                  label='Clique aqui para dar esta etapa como concluida'
                  hasArrow arrowSize={15}
                >
                  <a data-bt="check" onClick={() => onConcludeEtapa(etapa.id)}><FaCheck /></a>
                </Tooltip>
              )
            }
            {
              (etapa.status === 2) && (
                <>
                  {
                    (etapa.visivel) && (
                      <Tooltip
                        padding='2'
                        borderRadius='4'
                        placement='top'
                        color={'white'}
                        background={'var(--a4)'}
                        label='Clique para ocultar esta etapa para o gestor e colaborador'
                        hasArrow arrowSize={15}
                      >
                        <a data-bt="eye" onClick={() => onUpdateVisibility(etapa.id)}><FaEyeSlash /></a>
                      </Tooltip>
                    )
                  }

                  {
                    (!etapa.visivel) && (
                      <Tooltip
                        padding='2'
                        borderRadius='4'
                        placement='top'
                        color={'white'}
                        background={'var(--a4)'}
                        label='Clique para tornar visível esta etapa'
                        hasArrow arrowSize={15}
                      >
                        <a data-bt="eye" onClick={() => onUpdateVisibility(etapa.id)}><FaEye /></a>
                      </Tooltip>
                    )
                  }
                </>
              )
            }

          </EditMenu>
        )
      }
    </Flex>
  )
}
